import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('taxi-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/');
    if (err.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('taxi-token');
      localStorage.removeItem('taxi-user');
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

// ── Auth ─────────────────────────────────────────────────────────────────────
export const login          = (data)  => api.post('/auth/login', data);
export const register       = (data)  => api.post('/auth/register', data);
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword  = (token, newPassword) => api.post('/auth/reset-password', { token, newPassword });
export const verifyEmail        = (token) => api.get('/auth/verify-email', { params: { token } });
export const resendVerification = (email) => api.post('/auth/resend-verification', { email });

// ── Users ────────────────────────────────────────────────────────────────────
export const getUsers         = ()       => api.get('/users');
export const changePassword   = (data)   => api.put('/users/me/password', data);
export const setOnlineStatus  = (online) => api.put('/users/me/online', { online });
export const updatePhone      = (phone)  => api.put('/users/me/phone', { phone });

// ── Rides ────────────────────────────────────────────────────────────────────
export const createRide   = (data)         => api.post('/rides', data);
export const getAllRides      = (page = 0) => api.get('/rides', { params: { page, size: 20 } });
export const getMyDriverRides = (page = 0) => api.get('/rides/my-driver', { params: { page, size: 20 } });
export const getMyRides   = (page = 0)    => api.get('/rides/my', { params: { page, size: 20 } });
export const getNewRides  = ()             => api.get('/rides/new');
export const acceptRide   = (id)           => api.put(`/rides/${id}/accept`);
export const arriveRide   = (id, version)  => api.put(`/rides/${id}/arrive`, { version });
export const startRide    = (id, version)  => api.put(`/rides/${id}/start`, { version });
export const completeRide = (id, version)  => api.put(`/rides/${id}/complete`, { version });
export const cancelRide   = (id)           => api.put(`/rides/${id}/cancel`);
export const rateRide     = (id, rating, review) => api.put(`/rides/${id}/rate`, { rating, review });
export const rateClient   = (id, rating, review) => api.put(`/rides/${id}/rate-client`, { rating, review });
export const getDistance    = (from, to, signal) => api.get('/rides/distance', { params: { from, to }, signal });
export const suggestAddress   = (q)        => api.get('/rides/autocomplete', { params: { q } });
export const createSseTicket      = ()              => api.post('/rides/events/ticket');
export const updateDriverLocation = (id, lat, lng) => api.put(`/rides/${id}/driver-location`, { lat, lng });

// ── Notifications ────────────────────────────────────────────────────────────
export const getNotifications        = (page = 0) => api.get('/notifications', { params: { page, size: 20 } });
export const getUnreadNotificationCount = ()       => api.get('/notifications/unread-count');
export const markNotificationRead     = (id)       => api.put(`/notifications/${id}/read`);
export const markAllNotificationsRead = ()         => api.put('/notifications/read-all');

// ── Admin ─────────────────────────────────────────────────────────────────────
export const adminGetUsers      = ()              => api.get('/admin/users');
export const adminBlockUser     = (id)            => api.put(`/admin/users/${id}/block`);
export const adminUnblockUser   = (id)            => api.put(`/admin/users/${id}/unblock`);
export const adminGetRides      = (status = '')   => api.get('/admin/rides', { params: status ? { status } : {} });
export const adminCancelRide    = (id)            => api.put(`/admin/rides/${id}/cancel`);
